
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resize-jpg",
      function () {
        return require("private-next-pages/resize-jpg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resize-jpg"])
      });
    }
  